import React, { Fragment } from 'react';
import {
	Document,
	Font,
	Page,
	Text,
	Image,
	StyleSheet,
	View,
} from '@react-pdf/renderer';
import scheme from	'../../images/ground/select/ground_select_report_scheme.png'
import table from	'../../images/ground/select/table.png'
import logo from	'../../images/iek_logo.png'
import EmptySpace from './Components/EmptySpace'
import {List, ListItem} from './Components/BulletPiontList'


const styles = StyleSheet.create({
	body: {
		paddingTop: 35,
		paddingBottom: 65,
		paddingHorizontal: 35,
	},
	add:{
		fontFamily: 'Roboto',
		fontSize: 10,
	},
	doc_title: {
		fontSize: 24,
		textAlign: 'center',
		fontFamily: 'Roboto',
	},
	description: {
		fontSize: 12,
		fontFamily: 'Roboto',
		marginLeft: 12,
	},
	subtitle: {
		fontSize: 16,
		textAlign: 'center',
		fontFamily: 'Roboto',
		fontWeight:'bold'
	},
	text: {
		margin: 12,
		fontSize: 10,
		textAlign: 'justify',
		fontFamily: 'Roboto',
	},
	image: {
		marginLeft: 12,
		height:350,
		textAlign: 'center',
		objectFit:'contain'
	},
	logo: {
		position: 'absolute',
		top: 0,
		left: 0,
		marginLeft: 12,
		height:30,
		textAlign: 'center',
	},
	smallImage:{
		textAlign: 'center',
		height:150,
		objectFit:'contain'
	},
	pageNumber: {
		position: 'absolute',
		bottom: 18,
		right: 48,
		fontSize: 12,
		color: 'grey',
	},
	colon:{
		marginTop: 6,
		textAlign: 'center',
		fontSize: 12,
		color: 'grey',
		fontFamily: 'Roboto',
		paddingHorizontal: '20%'
	},
	tor:{
		position: 'absolute',
		top: 6,
		right: 12,
		fontSize: 12,
		color: 'grey',
		fontFamily: 'Roboto',
	},
	numberCell:{
		width: '10%',
		textAlign: 'center',
	},
	articleCell:{
		width: '20%',
		paddingRight:3
	},
	nameCell:{
		width: '55%',
		paddingRight:5
	},
	unitCell:{
		width: '10%',
		textAlign: 'center',
	},
	countCell:{
		width: '5%',
		textAlign: 'center',
	},
	smallFont:{
		fontSize:7
	},
	numberSmallCell:{
		width: '12%',
		textAlign: 'center',
		borderBottom:'1px solid #000',
		borderLeft:'1px solid #000',
	},
	articleSmallCell:{
		width: '17%',
		textAlign: 'center',
		borderBottom:'1px solid #000',
		borderLeft:'1px solid #000'
	},
	nameSmallCell:{
		width: '54%',
		paddingLeft:5,
		borderBottom:'1px solid #000',
		borderLeft:'1px solid #000'
	},
	unitSmallCell:{
		width: '12%',
		textAlign: 'center',
		borderBottom:'1px solid #000',
		borderLeft:'1px solid #000'
	},
	countSmallCell:{
		width: '5%',
		textAlign: 'center',
		borderBottom:'1px solid #000',
		borderLeft:'1px solid #000'
	},
	featureAttrSell:{
		width: '50%',
		textAlign: 'left',
		borderBottom:'1px solid #000',
	},
	featureValSell:{
		width: '50%',
		textAlign: 'left',
		borderBottom:'1px solid #000',
	},

	row: {
		flexDirection: "row",
		alignItems: "center",
	},
	big:{
		height:30,
	},
	small:{
		minHeight:20,
	},
	tableContainer: {
		flexDirection: "row",
		flexWrap: "wrap",
		fontSize:10,
		fontFamily: 'Roboto',
	},

});

Font.register({
	family: "Roboto",
	fonts: [
		{ src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf", fontWeight: 300 },
		{ src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-regular-webfont.ttf", fontWeight: 400 },
		{ src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-medium-webfont.ttf", fontWeight: 500 },
		{ src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf", fontWeight: 600 },
	]
});


const ItemsTable = ({ data }) => (
	<View style={styles.tableContainer}>
		<TableRow items={data} />
	</View>
);

const SmallItemsTable = ({data}) => (
	<View style={styles.tableContainer}>
		<SmallTableRow items={data} />
	</View>
)

const FeaturesTable = ({data}) => (
	<View style={styles.tableContainer}>
		<FeatureTableRow items={data} />
	</View>
)

const SmallTableRow = ({ items }) => {
	const rows = items.map((item, idx) => (
		<View style={{...styles.row}} key={'sml_tbl' + idx}>
			<View style={{...styles.numberSmallCell, ...styles.smallFont, ...styles.small, paddingTop:5, }}>
				<Text >{idx+1}</Text>
			</View>
			<View style={{...styles.articleSmallCell, ...styles.smallFont, ...styles.small, paddingTop:5}}>
				<Text >{item.article}</Text>
			</View>
			<View style={{...styles.nameSmallCell, ...styles.smallFont, ...styles.small, paddingTop:5}}>
				<Text >{item.name}</Text>
			</View>
			<View style={{...styles.countSmallCell, ...styles.smallFont,...styles.small, paddingTop:5}}>
				<Text>*</Text>
			</View>
			<View style={{...styles.unitSmallCell, ...styles.smallFont,...styles.small, paddingTop:5}}>
				<Text>{item.unit}</Text>
			</View>
		</View>
	));
	return <Fragment>{rows}</Fragment>;
};

const TableRow = ({ items }) => {
	const rows = items.map((item, idx) => (
		<View style={{...styles.row, ...styles.big}} key={'tbl' + idx}>
			<Text style={styles.numberCell}>{idx+1}</Text>
			<Text style={styles.articleCell}>{item.article}</Text>
			<Text style={styles.nameCell}>{item.name}</Text>
			<Text style={styles.unitCell}>{item.unit}</Text>
			<Text style={styles.countCell}>{item.count}</Text>
		</View>
	));
	return <Fragment>{rows}</Fragment>;
};

const FeatureTableRow = ({ items }) => {
	const rows = items.map((item, idx) => (
		<View style={{...styles.row, ...styles.big}} key={'tbl' + idx}>
			<View style={{...styles.featureAttrSell, ...styles.smallFont, ...styles.small,}}>
				<Text>{item.Attribute}</Text>
			</View>
			<View style={{...styles.featureValSell, ...styles.smallFont, ...styles.small,}}>
				<Text >{item.value} {item.unit}</Text>
			</View>
		</View>
	));
	return <Fragment>{rows}</Fragment>;
};

const Pasport = (props) => (props.list.map((item,idx) => <PasportItem key={'pasport'+idx} idx={idx} pasportItem={item}/>))

const PasportItem = (props) => {
	const {name, article, desc, url, features=[]} = props.pasportItem
	const idx = props.idx
	return <View break={idx > 0}>
			<Text style={{...styles.text, fontWeight:'bold', textAlign: 'center',}}>{name}</Text>
			<Image style={styles.smallImage} src={url}/>
			<Text style={styles.text}>Технические характеристики:</Text>
			<View  style={{ ...styles.tableContainer, width:'50%' , marginLeft: 12,}}>
				<View style={{ ...styles.row}} >
					<View style={{...styles.featureAttrSell, ...styles.smallFont, ...styles.small,}}>
						<Text >№ Изделия</Text>
					</View>
					<View style={{...styles.featureValSell, ...styles.smallFont, ...styles.small}}>
						<Text >{article}</Text>
					</View>
				</View>
				<FeaturesTable data={features} />
			</View>
			<Text style={styles.text}>{desc}</Text>
		</View>

}

export default (props) => {
	const {date, name, address, desc, author, position, vertGround, vDiamType, vDiam, vLength, vMaterial,
		hSection, hLength, hMaterial, points, imgData='', pasportList=[], listForTable=[]} = props
	return (
		<Document>
			<Page style={styles.body} wrap>

				{/*Header*/}
				<View fixed style={{marginBottom: 30}}>
					<View style={{width:'14%'}}>
						<Image style={styles.logo} src={logo}/>
					</View>
					<View style={styles.colon}>
						<Text
							render={({pageNumber}) => pageNumber === 1 ? date : name}
							fixed
						/>
					</View>
					<Text style={styles.tor}
								fixed
					>ИМПУЛЬС 1.0.0</Text>
				</ View>

				<Text
					style={styles.pageNumber}
					render={({pageNumber, totalPages}) => `${pageNumber} / ${totalPages}`}
					fixed
				/>

				{/*Page 1*/}
				<EmptySpace />
				<EmptySpace />
				<EmptySpace />
				<EmptySpace />
				<Text style={{...styles.description, textAlign: 'center'}}>{name}</Text>
				<EmptySpace />
				<Text style={{...styles.text, textAlign: 'center'}}>{address}</Text>
				<EmptySpace />
				<EmptySpace />
				<Text style={{...styles.description, textAlign: 'center'}}>ОТЧЕТ</Text>
				<Text style={{...styles.text, textAlign: 'center'}}>Молниезащита и заземление</Text>
				<Text style={{...styles.text, textAlign: 'center'}}>Подбор оборудования заземления</Text>
				<Text break/>

				{/*Page 2*/}
				<Text style={{...styles.subtitle, marginBottom:12}}>1 Описание объекта</Text>
				<Text style={styles.text}>Дата: {date}</Text>
				<Text style={styles.text}>Объект: {name}</Text>
				<Text style={styles.text}>Адрес: {address}</Text>
				<Text style={styles.text}>{desc}</Text>
				<Text style={styles.text}>Автор: {author}</Text>
				<EmptySpace />
				{imgData ? <Image style={styles.image} src={imgData}/> : null  }
				<EmptySpace />

				<Text break/>

				{/*Page 3*/}
				<Text style={{...styles.subtitle, marginBottom:12}}>2	Исходные данные </Text>
				<EmptySpace />
				<Text style={{...styles.text, marginLeft:24}}>Вид заземляющего устройства: <span style={{fontWeight:'bold'}}>Для молниезащиты</span></Text>
				<Text style={{...styles.text, marginLeft:24}}>Схема контура заземления: <span style={{fontWeight:'bold'}}>{position}</span></Text>
				<EmptySpace />
				<Text style={{...styles.description, marginLeft:24, marginBottom:1}}>Вертикальные заземлители</Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Количество, шт: <span style={{fontWeight:'bold'}}>{vertGround}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>{vDiamType}<span style={{fontWeight:'bold'}}>{vDiam}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Длина, м: <span style={{fontWeight:'bold'}}>{vLength}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Материал: <span style={{fontWeight:'bold'}}>{vMaterial}</span></Text>
				<EmptySpace />
				<Text style={{...styles.description, marginLeft:24, marginBottom:1}}>Горизонтальные заземлители</Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Сечение, мм: <span style={{fontWeight:'bold'}}>{hSection}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Длина, м: <span style={{fontWeight:'bold'}}>{hLength}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Материал: <span style={{fontWeight:'bold'}}>{hMaterial}</span></Text>
				<EmptySpace />
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Количество точек присоединения к контуру*: <span style={{fontWeight:'bold'}}>{points}</span></Text>
				<Text style={{...styles.text, marginLeft:36, marginBottom:1, marginTop:1}}>*соответствует колчеству опусков (токоотводов)</Text>
				<EmptySpace />

				<Text break/>
				<Text style={{...styles.subtitle, marginBottom:12}}>3	Результаты</Text>
				<Text style={styles.text}>Спецификация</Text>
				<View style={styles.tableContainer}>
					<View style={{...styles.row, ...styles.big, borderBottom:'2px solid #000',  borderTop:'2px solid #000', textAlign: 'center',}} key={'tbl'}>
						<Text style={styles.numberCell}>№ п/п</Text>
						<Text style={styles.articleCell}>Артикул</Text>
						<Text style={styles.nameCell}>Наименование</Text>
						<Text style={styles.unitCell}>Ед. изм.</Text>
						<Text style={styles.countCell}>Кол.</Text>
					</View>
				</View>
				<ItemsTable data={listForTable} />
				<Text break/>

				{/*Page 4*/}
				<Text style={{...styles.subtitle, marginBottom:12}}>4 Техпаспорта изделий </Text>
				{pasportList.length ? <Pasport list={pasportList} /> : null  }

				<Text break/>

				{/*Page 5*/}
				<Text style={{...styles.subtitle, marginBottom:12}}>4 Используемая литература</Text>
				<List>
						<ListItem>ПУЭ, 7-е издание “ПРАВИЛА УСТРОЙСТВА ЭЛЕКТРОУСТАНОВОК”</ListItem>
						<ListItem>СО 153-34.21.122-2003 «Инструкция по устройству молниезащиты зданий, сооружений и промышленных коммуникаций» </ListItem>
						<ListItem>РД 34.21.122-87 «Инструкция по устройству молниезащиты зданий и сооружений»</ListItem>
						<ListItem>ГОСТ 9.005-72 «МЕТАЛЛЫ, СПЛАВЫ, МЕТАЛЛИЧЕСКИЕ И НЕМЕТАЛЛИЧЕСКИЕ НЕОРГАНИЧЕСКИЕ ПОКРЫТИЯ»</ListItem>
				</List>

			</Page>
			<Page style={styles.add} size={'A4'}>
				<View style={{border:'1px solid #000', margin:'2%', width:'96%', height:'96%'}}>
					<View style={{border:'1px solid #000', marginTop:'2%', marginBottom:'2%', marginLeft:'6%',marginRight:'2%', width:'92%', height:'96%'}}>
						<View  style={{ ...styles.tableContainer, marginLeft:'25%', width:'75%'}}>
							<View style={{ ...styles.row}} >
								<View style={{...styles.numberSmallCell, ...styles.smallFont, ...styles.small,}}>
									<Text >Поз. обозначение</Text>
								</View>
								<View style={{...styles.articleSmallCell, ...styles.smallFont, ...styles.small, paddingTop:5}}>
									<Text >Артикул</Text>
								</View>
								<View style={{...styles.nameSmallCell, ...styles.smallFont, textAlign: 'center', ...styles.small, paddingTop:5}}>
									<Text >Наименование</Text>
								</View>
								<View style={{...styles.countSmallCell, ...styles.smallFont,...styles.small, paddingTop:5}}>
									<Text >Кол.</Text>
								</View>
								<View style={{...styles.unitSmallCell, ...styles.smallFont,...styles.small, paddingTop:5}}>
									<Text>Примечание</Text>
								</View>
							</View>
							<SmallItemsTable data={listForTable} />
						</View>
						<View>
							<Image style={{...styles.image, marginTop:10, height:470}} src={scheme}/>
						</View>
						<View style={{width:'80%', marginLeft:'20%', paddingTop:10, position:'absolute', bottom:0, right:0, height:150}}>
							<Image  style={{...styles.image, textAlign: 'right', position:'absolute', bottom:0, right:0, height:120}} src={table}/>
						</View>
					</View>
				</View>
			</Page>
		</Document>)
}






// WEBPACK FOOTER //
// ./src/react/ui/PDFCreation/PDFGroundSelectReport.js